import http from '../config/http';
import routes from '../config/api_routes';

export const getPartners = (page=1) => http(true).get(routes.partners.get.replace("pageNumber",page))
export const getPartnersSpotlight = () => http(true).get(routes.partners.spotlight);
export const getPartnerBySlug = (slug) => http(true).get(routes.partners.getBySlug.replace(':slug', slug));